import { Checkbox as AntdCheckbox } from "antd"

const Checkbox = props => {
  return <AntdCheckbox {...props}></AntdCheckbox>
}

export default Checkbox
